import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { BreakpointService } from '@shared/services/breakpoint.service';
import { ServerStatusService } from '@shared/services/server-status.service';
import { MainNavService } from '../components/main-nav/main-nav.service';
import { onMainNavChange } from '../components/main-nav/main-nav-animations';
import { NavigationEnd, Router } from '@angular/router';
import { MainTabsService } from '../components/main-tabs/main-tabs-service';
import { filter, map } from 'rxjs';
import { MainToolbarComponent } from '../components/main-toolbar/main-toolbar.component';
import { MatSidenavContainer, MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { MainSideNavComponent } from '../components/main-sidenav/main-sidenav.component';
import { MainTabsComponent } from '../components/main-tabs/main-tabs.component';

@Component({
  selector: 'app-default-template',
  templateUrl: './default-template.component.html',
  styleUrl: './default-template.component.scss',
  animations: [onMainNavChange],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MainToolbarComponent,
    MatSidenavContainer,
    MatSidenav,
    MainSideNavComponent,
    MatSidenavContent,
    MainTabsComponent,
  ],
})
export class DefaultTemplateComponent {
  private destroyRef = inject(DestroyRef);
  private serverStatus = inject(ServerStatusService);
  private router = inject(Router);
  private mainTabsService = inject(MainTabsService);
  readonly breakpointService = inject(BreakpointService);
  readonly isMobile = this.breakpointService.matches('lt-md');
  readonly isDesktop = this.breakpointService.matches('gt-sm');
  mainNavService = inject(MainNavService);

  public hoveringOverNav = false;

  readonly serverStatusMessage = toSignal(
    this.serverStatus.isServerOnline.pipe(
      map((status) => {
        if (this.serverStatus.isGoingOffline) {
          return `The Thrive server will go offline at ${new Date(status.offlineTime).toLocaleString()}`;
        } else if (!this.serverStatus.isOnline) {
          return 'The Thrive server is currently offline for maintenance';
        }
        return '';
      })
    ),
    { initialValue: '' }
  );

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        void this.mainTabsService.addTab(event.url);
      });
    if (this.mainNavService.getMenuState() !== this.mainNavService.mainNavOpen$.value) {
      setTimeout(() => {
        this.mainNavService.initialiseStoredNavState();
      }, 400);
    }
  }

  public toggleDrawerForMobile(): void {
    this.mainNavService.mainNavOpen$.next(true);
  }
}
